<template>
  <sidenav :orientation="orientation" :class="['custom-sidenav', curClasses]">
    <!-- Brand -->
    <div class="app-brand py-3">
      <router-link to="/" class="d-block w-100">
        <img src="/images/logo.png" alt class="app-brand-img" />
        <img
          src="/images/logo-small.png"
          alt
          class="app-brand-img-collapsed mx-auto"
        />
      </router-link>
      <a
        href="javascript:void(0)"
        class="layout-sidenav-toggle sidenav-link text-large ml-auto"
        @click="toggleSidenav"
      >
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <!-- / Brand -->

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
      <!-- Added Overview Link -->
      <sidenav-router-link  icon="ion ion-md-analytics" to="/" exact  style="text-decoration: none !important;">Overview</sidenav-router-link>

      <sidenav-router-link
        v-if="!isReportUser"
        icon="ion ion-md-trending-up"
        to="/trends"
        exact
      >
        Trends
      </sidenav-router-link>

      <sidenav-router-link icon="ion ion-md-cart" to="/sales" exact>Sales</sidenav-router-link>

      <sidenav-menu
        v-if="!isReportUser"
        icon="ion ion-ios-cog"
        :active="isMenuActive('/machines') || isMenuActive('/machines/archived')"
        :open="isMenuOpen('/machines') || isMenuOpen('/machines/archived')"
      >
        <template #link-text>Machines</template>
        <sidenav-router-link to="/machines" exact>Machines</sidenav-router-link>
        <sidenav-router-link to="/machines/archived" exact>Archived</sidenav-router-link>
      </sidenav-menu>

      <sidenav-router-link
        v-if="hasDeviceClaims && !isReportUser"
        icon="ion ion-md-finger-print"
        to="/devices"
      >
        Devices
      </sidenav-router-link>

      <sidenav-router-link
        v-if="hasGroupClaims && !isReportUser"
        icon="ion ion-md-cube"
        to="/groups"
      >
        Groups
      </sidenav-router-link>

      <sidenav-menu
        v-if="!isReportUser"
        icon="ion ion-ios-beaker"
        :active="isMenuActive('/products') || isMenuActive('/planograms') || isMenuActive('/priceLists')"
        :open="isMenuOpen('/products') || isMenuOpen('/planograms') || isMenuOpen('/priceLists')"
      >
        <template #link-text>Products</template>
        <sidenav-router-link to="/products" exact>Products</sidenav-router-link>
        <sidenav-router-link to="/planograms" exact>Planograms</sidenav-router-link>
        <sidenav-router-link to="/priceLists" exact>Price Lists</sidenav-router-link>
      </sidenav-menu>

      <sidenav-router-link v-if="!isReportUser" icon="ion ion-ios-flash" to="/attracts" exact>
        Attracts
      </sidenav-router-link>

      <sidenav-router-link v-if="!isReportUser" icon="ion ion-md-stats" to="/status" exact>
        Status
      </sidenav-router-link>

       <!-- <sidenav-menu
        v-if="!isReportUser"
        icon="ion ion-ios-beaker"
        :active="isMenuActive('/rmaRequest')"
        :open="isMenuOpen('/rmaRequest')"
      >
        <template #link-text>Support</template>
        <sidenav-router-link to="/rmaRequest" exact>RMA Request</sidenav-router-link>
          <sidenav-router-link   to="/dispenseEvents" :exact="true"
          v-if="hasUserEditClaims && (!isReportUser)">
          Servicing
        </sidenav-router-link>
         
      </sidenav-menu> -->

     

      <sidenav-router-link
        v-if="hasUserEditClaims && !isReportUser"
        icon="ion ion-md-contacts"
        to="/users"
        exact
      >
        Users
      </sidenav-router-link>
     

      <sidenav-menu
        icon="ion ion-md-archive"
        :active="isMenuActive('/Reports') || isMenuActive('/reports/transactions') || isMenuActive('/reports/bulkupdates')"
        :open="isMenuOpen('/Reports') || isMenuOpen('/reports/transactions') || isMenuOpen('/reports/bulkupdates') || isMenuOpen('/reports/rfidtags')"
        
      >
        <template #link-text>Reports</template>
        <sidenav-router-link to="/reports/transactions" exact v-if="hasReportsClaims">Transactions</sidenav-router-link>
        <sidenav-router-link to="/reports/devicetransactions" exact v-if="hasReportsClaims">Device Transactions</sidenav-router-link>
        <sidenav-router-link to="/reports/serviceforecast" exact v-if="hasReportsClaims">Service Forecast</sidenav-router-link>
        <sidenav-router-link to="/reports/bulkupdates" exact v-if="hasReportsClaims">Bulk Updates</sidenav-router-link>
        <sidenav-router-link to="/reports/cashupdates" exact v-if="hasReportsClaims">Cash Updates</sidenav-router-link>
        <sidenav-router-link to="/reports/events" exact v-if="hasReportsClaims">Events</sidenav-router-link>
        <sidenav-router-link to="/reports/deviceinteractions" exact v-if="hasReportsClaims">Device Interactions</sidenav-router-link>
        <sidenav-router-link to="/reports/weeklysales" exact v-if="hasReportsClaims">Weekly Sales</sidenav-router-link>
        <sidenav-router-link to="/reports/rfidtags" :exact="true" v-if="hasReportsClaims">
          RFID Tags
        </sidenav-router-link>
      </sidenav-menu>

      <sidenav-block>
        <small>{{ apiVersionString }}</small><br />
        <small>{{ uiVersionString }}</small>
      </sidenav-block>
    </div>
  </sidenav>
</template>

<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavBlock,
} from "@/vendor/libs/sidenav";
import toDateTime from "../filters/toDateTime";
import httpClient from "@/lib/httpClient";
import { version } from "../../package.json";
import { inject, ref, onMounted } from 'vue';

export default {
  name: "app-layout-sidenav",
  components: {
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavBlock,
  },
  props: {
    orientation: {
      type: String,
      default: "vertical",
    },
  },
  data() {
    return {
      hasUserEditClaims: false,
      hasGroupClaims: false,
      hasDeviceClaims: false,
      hasReportsClaims: false,
      versions: {},
      apiVersionString: "",
      uiVersionString: "",
      isReportUser: false,
    };
  },
  created() {
    this.loadData();
  },
  
  computed: {
    curClasses() {
      let bg = this.layoutSidenavBg;
      if (
        this.orientation === "horizontal" &&
        (bg.includes("sidenav-dark") || bg.includes("sidenav-light"))
      ) {
        bg = bg.replace("sidenav-dark", "").replace("sidenav-light", "");
      }
      return `bg-${bg} ${
        this.orientation !== "horizontal"
          ? "layout-sidenav"
          : "layout-sidenav-horizontal container-p-x flex-grow-0"
      }`;
    },
  },
  methods: {
    isMenuActive(url) {
      return this.$route.path.startsWith(url);
    },
    isMenuOpen(url) {
      return this.isMenuActive(url) && this.orientation !== "horizontal";
    },
    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },
    async loadData() {
      const auth = inject('auth'); // Injecting auth

      const claims = await auth.getAuthTokenClaims();
      this.hasUserEditClaims = claims.some((x) => x.startsWith("user:edit"));
      this.hasGroupClaims = claims.some((x) => x.startsWith("group:"));
      this.hasDeviceClaims = claims.some((x) => x.startsWith("device:"));
      this.hasReportsClaims = claims.some((x) =>
        ["sales:view.all", "sales:view.group", "sales:view.assigned"].some(
          (claim) => x.startsWith(claim)
        )
      );

      try {
        const { data } = await httpClient.get("/system/info");
        this.versions = data;
        this.apiVersionString = `API v${this.versions.apiVersion}`;
        this.uiVersionString = `UI v${version}`;

        const roles = await auth.getUserRoles();
        this.isReportUser = roles.includes("reportuser");
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>


<style  >
.custom-sidenav {
  background-color: #22A2E6; /* Custom background color */
  color: white; /* Font color */
}

.custom-sidenav .sidenav-inner a,
.custom-sidenav .sidenav-router-link {
  color:rgb(232, 223, 223) !important; /* Ensures links are white */
  text-decoration: none !important; /* Hides underline */
}

.custom-sidenav .sidenav-inner a:hover,
.custom-sidenav .sidenav-router-link:hover {
  color: rgb(240, 251, 251) !important; /* Keep the color same as normal */
  text-decoration: none !important; /* Ensure no underline on hover */
}

/* Add this to specifically target Vue Router's active class */
.custom-sidenav .sidenav-router-link.router-link-active {
  text-decoration: none !important; /* Ensure no underline when active */
}
</style>

